import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-users-permissions',
  templateUrl: './users-permissions.component.html',
  styleUrls: ['./users-permissions.component.sass']
})
export class UsersPermissionsComponent implements OnInit {
public sessionView;
public name;
public lastName;
public email;
public acount;
public phoneNumber;
public idRole;
public tunnel;
public typeOfAction;
public token;
public role;
public tabActive='Manejo de Cuenta';
  constructor(private global:GlobalService,private services: Service,private loadingScreenService :LoadingScreenService,public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Usuarios y Permisos");
    this.AngularFireAnalytics.logEvent("Usuarios y Permisos-Screenview");
   }
  ngOnInit() {
    this.global.validateSession();
    this.token=sessionStorage.getItem("token");
    if(sessionStorage.getItem("tunnel")=="null"){
      this.sessionView=1;
      this.typeOfAction='add';
    }
    else{
      this.tunnel=JSON.parse(atob(sessionStorage.getItem("tunnel")));
      if(this.tunnel!=undefined && this.tunnel!="" && this.tunnel!=null){
        this.sessionView=2;
        this.typeOfAction='edit';
      }
      else{
        this.sessionView=1;
        this.typeOfAction='add';
      }
    }
  }
}